<template>
<div class="sidebar-wrap left">
    <RightMenuSidebar></RightMenuSidebar>
    <RightMenuTag></RightMenuTag>
    <!-- menu di chuyển mail -->
    <DialogEditFolderSearch></DialogEditFolderSearch>
    <DialogAddFolder ref="dialogAddFolder"></DialogAddFolder>
    <DialogEditName></DialogEditName>
    <DialogMoveFolder></DialogMoveFolder>
    <DialogAddMoveFolder/>
    <DialogShareFolder :is-briefcase="$route.path.includes('briefcase')"></DialogShareFolder>
    <DialogEditFolder></DialogEditFolder>
<!--    <DialogZimletYahoo></DialogZimletYahoo>-->
<!--    <DialogZimletArchire></DialogZimletArchire>-->
    <DialogRedirect></DialogRedirect>
    <RightMenuMailFolder></RightMenuMailFolder>
    <DialogAddShareFolder :defaultType="$route.path.includes('briefcase')? FOLDER_VIEW.DOCUMENT : FOLDER_VIEW.MESSAGE"></DialogAddShareFolder>
    <DialogFolderSelector></DialogFolderSelector>
    <!-- bộ lọc -->
    <DialogFilterActivityStream></DialogFilterActivityStream>
    <base-dialog-filter>
    </base-dialog-filter>
    <DialogCreateFolder />
    <dialog-add-tag/>
    <DialogReNameTag/>
    <DialogWarningCalendar ref="refDialogWarningCalendar" @fActionMoreDetail="actionMoreDetail"/>
    <template v-if="showCalendarForm">
        <CalendarForm ref="refCalendarForm"/>
    </template>
<!--    <DialogWebexPreferences/>-->

</div>
</template>

<script>
import DialogWarningCalendar from "@/components/modules/calendar/components/warning-calendar/dialog-warning-calendar";
import CalendarForm from "@/components/modules/calendar/calendar-form/calendar-form";
// import DialogWebexPreferences from "@/components/modules/calendar/components/dialogs/dialog-webex-preferences.vue"
import DialogFolderSelector from "./components/DialogFolderSelector";
import DialogAddShareFolder from "./components/DialogAddShareFolder.vue";
import DialogRedirect from "./components/DialogRedirect";
import RightMenuSidebar from "./components/RightMenuSidebar";
import DialogEditFolderSearch from "./components/DialogEditFolderSearch";
import RightMenuTag from "@/components/modules/layouts/components/RightMenuTag";
import DialogAddTag from "@/components/modules/layouts/components/DialogAddTag";
import DialogReNameTag from "@/components/modules/layouts/components/DialogReNameTag";
import DialogEditFolder from "./components/DialogEditFolder";
import DialogShareFolder from "./components/DialogShareFolder";
import DialogMoveFolder from "./components/DialogMoveFolder";
import DialogAddFolder from "./components/DialogAddFolder";
import DialogAddMoveFolder from "./components/DialogAddMoveFolder";
import { FOLDER_VIEW } from "@/utils/constants"
// import DialogZimletYahoo from "./components/DialogZimletYahoo";
// import DialogZimletArchire from "./components/DialogZimletArchire";
import DialogFilterActivityStream from "@/components/modules/layouts/components/setting/filter/DialogFilterActivityStream.vue";
import BaseDialogFilter from "@/components/modules/base/base-dialog-filter";
import DialogCreateFolder from "@/components/modules/layouts/components/DialogCreateFolder.vue";
import DialogEditName from "./components/DialogEditName";
import RightMenuMailFolder from "./components/RightMenuMailFolder";
import CommonUtils from "@/utils/common-utils";
import EmailUtils from "@/utils/email-utils";
import {mapActions, mapGetters} from "vuex";
// import MenuChatLeft from "@/components/modules/layouts/components/side-bar-left/MenuChatLeft";
export default {
    name: "FunctionApp",
    mixins: [CommonUtils, EmailUtils],
    components:{
            RightMenuSidebar,
            DialogWarningCalendar,
            CalendarForm,
            DialogReNameTag,
            DialogAddFolder,
            DialogEditName,
            // MenuChatLeft,
            RightMenuTag,
            DialogMoveFolder,
            DialogAddTag,
            DialogAddMoveFolder,
            DialogShareFolder,
            DialogEditFolder,
            // DialogZimletYahoo,
            // DialogZimletArchire,
            DialogEditFolderSearch,
            DialogRedirect,
            RightMenuMailFolder,
            DialogAddShareFolder,
            DialogFilterActivityStream,
            DialogFolderSelector,
            BaseDialogFilter,
            DialogCreateFolder,
            // DialogWebexPreferences
    },
    data() {
        return {
            FOLDER_VIEW: FOLDER_VIEW,
            showCalendarForm: false,
        }
    },
    computed: {
        ...mapGetters([
            "dataSidebarExtend",
            "dataSidebarInBox"
        ])},
    methods: {
        ...mapActions(["actionToggleMenuCollapse"]),
        actionMoreDetail(modelData) {
            this.showCalendarForm = true;
            this.$nextTick(() => {
                this.$refs.refCalendarForm && this.$refs.refCalendarForm.show(null, null, modelData);
            });
        },
    },
    created() {
        this.$root.$on("updateItemToDataInBox", (itemUpdate) => {
            this.updateItemToData(itemUpdate, this.dataSidebarInBox);
        });
        this.$root.$on("updateItemToDataExtend", (itemUpdate) => {
            this.updateItemToData(itemUpdate, this.dataSidebarExtend);
        });
        this.$root.$on("addItemToDataInBox", (itemAdd) => {
            this.addItemToData(itemAdd, this.dataSidebarInBox);
        });
        this.$root.$on("addItemToDataExtend", (itemAdd) => {
            this.addItemToData(itemAdd, this.dataSidebarExtend);
        });
        this.$root.$on("deleteItemToDataInBox", (itemAdd) => {
            const data = this.deleteItemToData(itemAdd, this.dataSidebarInBox);
            if (data) {
                this.$store.commit("SET_DATA_INBOX", data);
            }
        });
        this.$root.$on("deleteItemToDataExtend", (itemAdd) => {
            this.deleteItemToData(itemAdd, this.dataSidebarExtend);
        });
    }
}
</script>

<style scoped>

</style>
